import { useState } from 'react';
import { communityBoards } from '@/mocks/community';

interface NewTopicModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { title: string; board: string; content: string }) => void;
}

export default function NewTopicModal({ open, onClose, onSubmit }: NewTopicModalProps) {
  const [title, setTitle] = useState('');
  const [board, setBoard] = useState('latest');
  const [content, setContent] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const submit = () => {
    if (!title.trim()) {
      setError('请填写话题标题');
      return;
    }
    if (!content.trim()) {
      setError('请填写话题内容');
      return;
    }
    onSubmit({ title: title.trim(), board, content: content.trim() });
    setTitle('');
    setContent('');
    setBoard('latest');
    setError('');
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4" role="dialog" aria-modal="true">
      <button
        type="button"
        aria-label="关闭"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/40 cursor-pointer"
      ></button>
      <div className="relative w-full max-w-lg rounded-lg bg-background-50 p-6 animate-fade-up max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between gap-4">
          <h3 className="font-heading text-lg font-bold text-foreground-950">发布新话题</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:bg-background-100 transition-colors"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-2" htmlFor="topic-title">
              话题标题
            </label>
            <input
              id="topic-title"
              type="text"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              placeholder="用一句话说清你想聊什么"
              className="w-full rounded-md border border-background-200 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
            />
          </div>

          <div>
            <span className="block text-sm font-medium text-foreground-700 mb-2">发布板块</span>
            <div className="flex flex-wrap gap-2">
              {communityBoards.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => setBoard(item.key)}
                  className={`rounded-full px-3.5 py-1.5 text-sm whitespace-nowrap transition-colors ${
                    board === item.key
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-2" htmlFor="topic-content">
              话题内容
            </label>
            <textarea
              id="topic-content"
              value={content}
              onChange={(event) => setContent(event.target.value.slice(0, 500))}
              rows={5}
              placeholder="展开说说你的想法吧（最多 500 字）"
              className="w-full rounded-md border border-background-200 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:bg-background-50 transition-colors resize-none"
            ></textarea>
            <p className="mt-1 text-right text-xs text-foreground-400">{content.length}/500</p>
          </div>

          {error ? (
            <p className="flex items-center gap-1.5 text-sm text-accent-600">
              <i className="ri-error-warning-line"></i>
              {error}
            </p>
          ) : null}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 whitespace-nowrap rounded-md border border-background-200 px-4 py-2.5 text-sm font-medium text-foreground-600 hover:bg-background-100 transition-colors"
          >
            取消
          </button>
          <button
            type="button"
            onClick={submit}
            className="flex-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            发布话题
          </button>
        </div>
        <p className="mt-3 text-center text-xs text-foreground-400">
          当前为前端演示，发布内容仅在本页临时展示
        </p>
      </div>
    </div>
  );
}